import styled from '../../settings/styled';

type Variant = 'tiny' | 'small' | 'normal' | 'large' | 'xlarge';

const Spacer = styled.div<{ variant: Variant }>`
  margin: ${props => props.theme.spacing[props.variant]} 0;
`;

export default Spacer;
